module.exports = __webpack_public_path__ + "static/pay-by-link-preview-es-f95c7d392f557fd4ce92698bb837c85c.png";